import {
  Courier,
  CourierResponse,
  CourierService,
  CourierServicesResponse,
  PincodeZone,
  PincodeZonesResponse
} from '../types/pincode';
import { api } from './api';

class PincodeService {
  // Fetch all active couriers
  async getAllCouriers(): Promise<Courier[]> {
    const { data } = await api.get<CourierResponse>('/courier/all');
    // Map API response to your interface (id & name)
    return (data.courier_list ?? []).map(c => ({
      id: c.courier_id.toString(),
      name: c.name
    }));
  }

  // Fetch all services for a courier
  async getCourierServices(courierId: string): Promise<CourierService[]> {
    const { data } = await api.get<CourierServicesResponse>(`/courier/${courierId}/services`);
    return (data.services ?? []).map(s => ({
      id: s.id?.toString() ?? s.service_id?.toString() ?? '',
      name: s.name
    }));
  }

  // Fetch serviceable zones for a courier + pin codes
async getPincodeZones(
  userId: string,
  courierId: string,
  pickupPincode: string,
  deliveryPincode: string
): Promise<PincodeZone[]> {
  const { data } = await api.get<PincodeZonesResponse>(
    `/courier/${userId}/zones?courier_id=${courierId}&pickup_pincode=${pickupPincode}&delivery_pincode=${deliveryPincode}`
  );

  return (data.zones ?? []).map(z => ({
    courierId: String(z.courierId ?? z.courier_id ?? ''), // <- force to string
    zone: z.zone,
    serviceable: z.serviceable
  }));
}

  // Upload pincode serviceability Excel
  async uploadPincodeServiceabilityExcel(
    file: File,
    courierId: string | number,
    weightCategory: string
  ): Promise<{ success: boolean; message: string; code: number }> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('courierId', String(courierId));
    formData.append('weightCategory', weightCategory);

    const { data } = await api.post('/courier/serviceability/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return data;
  }
}

export const pincodeService = new PincodeService();
